import { client } from "../client";
import { Announcement } from "../types/announcement.types";

export const createAnnouncement = async ({
	content,
	title,
}: Partial<Announcement>) => {
	const response = await client.post<Announcement>("/announcements/", {
		title,
		content,
	});
	return response.data;
};

export const updateAnnouncement = async ({
	id,
	content,
	title,
}: Partial<Announcement>) => {
	const response = await client.patch<Announcement>(`/announcements/${id}`, {
		title,
		content,
	});
	return response.data;
};
